import { JSX } from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '@/utils/ProtectedRoute';
import { usePartnerData } from '@/providers/PartnerData.provider';
import { usePermissions } from '@/providers/Permissions.provider';
import OnboardingTrackerPage from './OnboardingTrackerPage';

export default function Routes(): JSX.Element {
  const { permissions } = usePermissions();

  const {
    response: { isRoleAdmin, isRoleViewOnly },
  } = usePartnerData();

  // Support users are excluded, as the old tracker's login rejects them.
  const isAllowed = permissions.accountOnboardingFormAccess && (isRoleAdmin || isRoleViewOnly);

  return (
    <Switch>
      <ProtectedRoute isAllowed={isAllowed} showPermission exact path="/onboarding-form-tracker-new">
        <OnboardingTrackerPage />
      </ProtectedRoute>
    </Switch>
  );
}
